module.exports = __webpack_public_path__ + "static/media/_guernsey.3f7d88a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_guernsey.svg
// module id = 2326
// module chunks = 7